<template>
  <div class="form__field-box form__visible-datepicker" :data-vv-as="label" data-vv-value-path="model">
    <label class="form__label" v-if="label">{{label}}</label>
    <div
      class="v-input v-input__datetimepicker"
      :class="{ 'v-input--is-dirty': isDirty, 'v-input--is-disabled': disabled,
      'v-input__error--border': !!errors.has(newName) }"
    >
      <input
        class="v-input__field"
        v-model="model"
        type="text"
        @change="$emit('input', model)"
        v-validate="`date_format:DD-MM-YYYY`"
        ref="picker"
        :name="name"
        @input="$emit('input', model)"
        :disabled="disabled"
      >

      <input type="hidden" v-model="hidden" :name="name">

      <!--       <div class="v-input__error" v-if="errors.has(newName)">
        {{ errors.first(newName) }}
      </div>-->
    </div>
  </div>
</template>

<script>
import field from "../mixins/field";
import $ from "jquery";
import "tempusdominus-bootstrap-4";

export default {
  computed: {
    hidden() {
      if (this.model) {
        let datetime = this.model.split(" ");
        let date = datetime[0].split("-");
        let time = "";

        if (datetime[1]) {
          time = " " + datetime[1];
        }
        return date[0] && date[1] && date[2]
          ? `${date[2]}-${date[1]}-${date[0]}${time}`
          : "";
      }

      return "";
    }
  },
  mounted() {
    moment.updateLocale("en", {
      week: { dow: 1 } // Monday is the first day of the week
    });
    var todayDate = moment().startOf('day');
    if (!this.pastDates) {
      $(this.$refs.picker).datetimepicker({
        format: this.format,
        minDate: todayDate,
        disabledDates: this.excludedDates,
        daysOfWeekDisabled: this.excludedDays,
        inline: true
      });
    } else {
      if (this.decades) {
        $(this.$refs.picker).datetimepicker({
          format: this.format,
          viewMode: "decades",
          inline: true
        });
      } else {
        $(this.$refs.picker).datetimepicker({
          format: this.format,
          inline: true
        });
      }
    }

    this.model = this.$refs.picker.value;

    $(this.$refs.picker).on("input.datetimepicker", e => {
      this.model = e.target.value;
    });
  },
  mixins: [field],
  props: {
    decades: false,
    pastDates: {
      default: true,
      type: Boolean
    },
    format: {
      default: "DD-MM-YYYY",
      type: String
    },
    excludedDays: {
      default: [],
      type: Array
    },
    excludedDates: {
      default: [],
      type: Array
    }
  }
};
</script>

<style>
.bootstrap-datetimepicker-widget .list-unstyled {
  list-style: none;
  padding: 0;
  margin: 0;
}
.bootstrap-datetimepicker-widget {
  background: #fff;
  border: 1px solid #dcdbdb;
}
.bootstrap-datetimepicker-widget table td.active,
.bootstrap-datetimepicker-widget table td span.active {
  background-color: #26a69a;
}
.bootstrap-datetimepicker-widget table td.active:hover {
  background-color: #006c5f;
}
.v-input__datetimepicker.v-input__error--border .v-input__field {
  border-color: red;
}
.v-input__datetimepicker.v-input__error--border {
  box-shadow: none;
}
</style>